export const msalConfig = {
  auth: {
    clientId: "e114e9c7-37fc-4eee-a31a-ad97405a33ac",
    authority: "https://login.microsoftonline.com/405f07c7-a28c-4624-854e-820e6e6dcec8",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  }
}

export const loginRequest = {
  scopes: ["User.Read", "User.ReadBasic.All", "openid", "profile"]
}

// Scope de l'API TheCrowd elle-même (Expose an API → access_as_user).
// Utilisé pour attacher un token Authorization: Bearer aux appels vers
// pilotage-management-api (voir services/api.js — setTokenProvider).
export const apiRequest = {
  scopes: ["api://e114e9c7-37fc-4eee-a31a-ad97405a33ac/access_as_user"]
}

export const API_BASE_URL = "https://thecrowd.hopscotchgroupe.info"
